// conversationActions.ts
import { uiChatReducerActionTypes } from "./uiChatTypes";

export const uiChatApiResponseSuccess = (actionType: string, data: any) => ({
  type: uiChatReducerActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// Action to handle API error
export const uiChatApiResponseError = (actionType: string, error: string) => ({
  type: uiChatReducerActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getSystemResponseAction = (response: {
  file: File;
  transcript: string,
  entry_json: any,
  detected_language: string | null,
  time_difference: number | null; // seconds since previous screen load
  previous_agent_log_id: number | null; // seconds since previous screen load
  page?: string | null



}) => ({
  type: uiChatReducerActionTypes.GET_SYSTEM_RESPONSE,
  payload: response
});

export const detectedLanguageAction = (response: any) => ({
  type: uiChatReducerActionTypes.DETECTED_LANGUAGE,
  payload: response
});


export const sendApproveEntryAction = (response: any) => ({
  type: uiChatReducerActionTypes.SEND_APPROVED_ENTRY,
  payload: response
});


// action to fetch details from  Aadhar card photo :  extractIdDetails

export const sendIdentityDocumentAction = (response: { front: File, back?: File }) => ({
  type: uiChatReducerActionTypes.SEND_IDENTITY_DOCUMENT,
  payload: response
});
// export const sendIdentityDocumentAction = (response: { file: File; document_type?: string; booking_id?: string; guest_id?: string }) => ({
//   type: uiChatReducerActionTypes.SEND_IDENTITY_DOCUMENT,
//   payload: response
// });


// action to fetch details from  Aadhar card photo :  resetGuests

export const resetIdentityDocumnetDataAction = () => ({
  type: uiChatReducerActionTypes.RESET_IDENTITY_DOCUMENT,
  payload: {}
});


//action to delete Document 
// Action to delete identity document
export const deleteIdentityDocumentAction = (payload: {
  image_path: string;
  guest: any;  // guest object reference
  docType: string; // Aadhaar, PAN, etc.
}) => ({
  type: uiChatReducerActionTypes.DELETE_IDENTITY_DOCUMENT,
  payload,
});



// Load entire UI state from a JSON file (browser File)
export const loadInitialStateFromFileAction = () => ({
  type: uiChatReducerActionTypes.LOAD_INITIAL_STATE_FROM_FILE,

});

// Save current UI state to a JSON file (triggers a download)
export const saveStateToFileAction = (payload?: { filename?: string }) => ({
  type: uiChatReducerActionTypes.SAVE_STATE_TO_FILE,
  payload: payload || {}
});


export const sendManuallyUpdatedEntryAction = (response: any) => ({
  type: uiChatReducerActionTypes.SEND_MANUALLY_UPDATED_ENTRY,
  payload: response
});



export const setuiComponentAction = (response: any) => ({
  type: uiChatReducerActionTypes.SET_UICOMPONENT,
  payload: response
});